import type { IconButtonProps } from './IconButton';

export const DEFAULT_PROPS = {
  size: 'md',
  colorScheme: 'default',
} as const satisfies IconButtonProps;
